import { Pipe, PipeTransform } from '@angular/core';
import { ICharge } from '../../../pages/core/models/Commerce';
import { IChargePayment } from '../../../pages/core/models/Transactions';
import { Utils } from '../../../pages/core/utils/Utils';

@Pipe({
  name: 'getConvertedChargeFee',
})
export class GetConvertedChargeFeePipe implements PipeTransform {
  transform(charge: ICharge): string {
    let tooltipMessage = '';
    const usdtPrice = charge.pricing.find((coin) => coin.currency == 'USDT');
    const percentFee = (+charge.fee * 100) / +usdtPrice.amount / 100;
    const coinsFee: { coin: string; fee: number }[] = [];

    charge.payments.forEach(({ coin, value }) => {
      const index = coinsFee.findIndex((coinFee) => coinFee.coin === coin);
      if (index == -1) {
        coinsFee.push({ coin, fee: +value.human * percentFee });
      } else {
        coinsFee[index].fee += +value.human * percentFee;
      }
    });

    if (coinsFee.length == 1) {
      tooltipMessage += `Fee de ${coinsFee[0].coin} ${Utils.parseNumberToCurrencyString(
        coinsFee[0].fee.toFixed(2),
      )}`;
    } else {
      coinsFee.forEach((coinFee, index) => {
        tooltipMessage += `Fee de ${coinFee.coin} ${Utils.parseNumberToCurrencyString(
          coinFee.fee.toFixed(2),
        )}`;

        if (index < coinsFee.length - 1) {
          tooltipMessage += '<br/>';
        }
      });
    }

    return tooltipMessage;
  }
}
